module.exports = __webpack_public_path__ + "static/media/spiral.677cd228.jpeg";